import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";
import React, { useState, useEffect } from "react";
import { Card, Row } from "react-bootstrap";

import { FaPencilAlt } from "react-icons/fa";

import axios from "axios";
import { GET_PAGE_TITLES, UPDATE_PAGE_TITLE } from "URLRoutes";
import { generateURLOptions } from "URLOptions";
import EditPageTitles from "./Modals/EditPageTitles";

const PageTitlesEditor = () => {
  const [pageTitles, setPageTitles] = useState([]);

  const [selectedPageTitle, setSelectedPageTitle] = useState(null);
  const [showPageTitle, setShowPageTitle] = useState(false);

  useEffect(() => {
    document.title = "In-App Page Titles | Administration Panel | Mind Pulse ";
    getPageTitles();
  }, []);

  const getPageTitles = async () => {
    await axios
      .get(GET_PAGE_TITLES, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
        setPageTitles(response?.data?.data);
      })
      .catch((error) => {
        console.log("Login Error: ", error);
        return alert(error);
      });
  };

  const updatePageTitle = async (data) => {
    await axios
      .post(UPDATE_PAGE_TITLE, data, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
        getPageTitles();
        setShowPageTitle(false);
        setSelectedPageTitle(null);
      })
      .catch((error) => {
        console.log("Login Error: ", error);
        return alert(error);
      });
  };

  const columns = [
    {
      accessor: "_id",
      Header: "No",
      Cell: (rowData) => {
        return parseInt(rowData.row.id) + 1;
      },
    },
    {
      accessor: "page",
      Header: "Page",
    },
    {
      accessor: "heading",
      Header: "Heading",
    },
    {
      accessor: "createdAt",
      Header: "Action",
      Cell: (rowData) => {
        const data = rowData.row.original;
        return (
          <>
            <div className="t-action-btn">
              <button
                className="btn btn-info"
                onClick={() => {
                  setSelectedPageTitle(data);
                  setShowPageTitle(true);
                }}
              >
                <FaPencilAlt />
              </button>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <EditPageTitles
        isOpen={showPageTitle}
        onClose={() => setShowPageTitle(false)}
        item={selectedPageTitle}
        onSubmit={updatePageTitle}
      />
      <AdvanceTableWrapper
        columns={columns}
        data={pageTitles}
        sortable
        pagination
        perPage={10}
      >
        <div
          style={{ borderRadius: "0.375rem" }}
          className="py-4 bg-white mb-3 d-flex align-items-center px-3"
        >
          <h5 className="hover-actions-trigger mb-0">In-App Page Titles</h5>
        </div>
        <Card className="mb-3">
          <Row className="flex-end-center mb-3">
            <AdvanceTable
              table
              headerClassName="bg-200 text-900 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                bordered: true,
                striped: true,
                className: "fs--1 mb-0 overflow-hidden",
              }}
            />
          </Row>
        </Card>

        <div className="mt-3">
          <AdvanceTableFooter
            rowCount={pageTitles.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
          />
        </div>
      </AdvanceTableWrapper>
    </>
  );
};

export default PageTitlesEditor;
